// removed by extract-text-webpack-plugin
module.exports = {"variables":"\"../../../assets/stylesheets/variables.css\"","customWhite":"#ffffff","genericContainer":"_2ELtkcMpIJZ1yyH_kfj3I7","mediumMaxWidth":"1199px","smallMaxWidth":"991px","extraSmallMaxWidth":"767px","mobileThreshold":"575px","container":"_2Pv2Dg_1z27CxbpUX0vCDK","containerWithoutImage":"CHWckBu6EFQTwWtacUiZY","titleContainer":"IYjOE75ps2QJCAKznJt2I _2ELtkcMpIJZ1yyH_kfj3I7","title":"_1M083c2o2Dfwgy-twX7x6W"};


//////////////////
// WEBPACK FOOTER
// ./src/pages/product-group/category-banner/CategoryBanner.css
// module id = 1066
// module chunks = 1